import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    '& .MuiDialogContent-root': {
      padding: theme.spacing(0),
      height: theme.spacing(81),
    },

    '& .MuiDialogTitle-root': {
      height: 'auto',
    },

    '& .MuiPaper-root.MuiDialog-paperFullScreen': {
      borderRadius: theme.spacing(0),

      '& .MuiDialogTitle-root': {
        display: 'flex',
        flexDirection: 'column-reverse',
        justifyContent: 'space-around',
        padding: theme.spacing(2, 2.375, 2, 3.125),
        width: '100%',

        '& button': {
          alignSelf: 'flex-end',
        },

        [theme.breakpoints.down('lg')]: {
          justifyContent: 'flex-end',
          padding: theme.spacing(0),
          height: theme.spacing(8.5),

          '& button': {
            margin: theme.spacing(1.25, 2, 0, 0),
          },
        },
      },
    },
  },

  content: {
    flexDirection: 'column',
    padding: theme.spacing(2, 2, 0, 2),
  },

  header: {
    display: 'flex',
    flex: 1,
    paddingBottom: theme.spacing(3.75),
  },

  title: {
    fontWeight: 500,
    textAlign: 'center',
    letterSpacing: '0.10px',
    fontFamily: '"Bebas Neue"',
    textTransform: 'uppercase',
    fontSize: theme.spacing(6),
    lineHeight: 1,
    width: '100%',
    paddingTop: theme.spacing(4),

    [theme.breakpoints.down('lg')]: {
      fontWeight: 400,
      position: 'absolute',
      top: theme.spacing(3.75),
      fontSize: theme.spacing(4),
      paddingTop: theme.spacing(0),
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      padding: theme.spacing(0, 1),
    },
  },

  forceRunButton: {
    '&.MuiButton-root': {
      marginBottom: theme.spacing(1),
    },
  },
}));
